export class ProgramAlreadyExistsMessage {
    public name: string;
    
    constructor(name: string)
    {
        this.name = name;
    }
}